import { ownership } from './programmes/ownership.js';
import { management_control } from './programmes/management_control.js';
import { skill_development } from './programmes/skill_development.js';
import { esd } from './programmes/esd.js';
import { sed } from './programmes/sed.js';
import { yes } from './programmes/yes.js';

export const programmesData = {
  ownership,
  management_control,
  skill_development,
  esd,
  sed,
  yes,
};
